
<script>
// import SlDateTime from '../components/shared/DatePicker'
import { date } from 'quasar'
import Grid from "src/components/Shared/Grid";
import DetailsModal from "src/components/Shared/DetailsModal";
import OrderManagementModal from "src/components/Order/OrderManagementModal";
import OrderTypeModal from "src/components/Order/OrderTypeModal";
import { mapMutations, mapState, mapActions, mapGetters } from "vuex";
import { lkKey } from "src/utils";
import { min } from 'moment';
import UserAutoComplete from '../components/User/UserAutoComplete'

const moment = require("moment");

export default {
  name: "Orders",
  components: {
    Grid,
    DetailsModal,
    OrderManagementModal,
    UserAutoComplete
  },
  created(){
    this.fetchSearchOrderTypes()
    this.selectUser(null)
  },
  data() {
    return {
      module: this.$route.meta.module,
      filterable: true,
      pagination: {
        rowsNumber: 0,
        rowsPerPage: 10,
        page: 1,
        descending: true,
        sortBy: "DATE_CREATED"
      },
      visibleColumns: ['ORDER_ID', 'DATE_CREATED', 'STATUS','USER', 'TOTAL', 'NOTES', 'CLASS_ID'],
      columnOptions: [
        {
          field: "ORDER_ID",
          name: "ORDER_ID",
          label: "Order ID",
          sortable: true,
          filterable: true,
          type: "string",
          align: "left",
          width: "90px"
        },        
        {
          field: "DATE_CREATED",
          name: "DATE_CREATED",
          label: "Order Date",
          sortable: true,
          filterable: false,
          type: "date",
          align: "left",
          format: value => {
            return this.formattedDate(value);
           
          }
        },
        {
          field: "CLASS_START_DATE",
          name: "CLASS_START_DATE",
          label: "Class Date",
          sortable: true,
          filterable: false,
          type: "date",
          align: "left",
          format: value => {
            return this.formattedDate(value);
           
          }
        },
        {
          field: "STATUS",
          name: "STATUS",
          label: "Status",
          sortable: true,
          filterable: true,
          type: "string",
          align: "left",
          format: value => {
            return value
            // return value ? `${lkKey("LK_ORDER_STATUS_ID", value)}` : null;
          }
        },
        {
          field: "NOTES",
          name: "NOTES",
          label: "Notes",
          sortable: true,
          filterable: true,
          type: "string",
          align: "left",
        },
        {
          field: "USER",
          align: "left",
          name: "USER",
          label: "Placed By",
          sortable: true,
          filterable: true,
          type: "string"
        },
        {
          field: "CLASS_ID",
          name: "CLASS_ID",
          label: "Related Class ID",
          sortable: true,
          filterable: true,
          type: "string",
          align: "left",
          width: "90px"
        },
        {
          field: "TOTAL",
          name: "TOTAL",
          label: "Total",
          sortable: true,
          filterable: false,
          type: "number",
          format: value => {
            return value != undefined ? `$${parseFloat(value).toFixed(2)}` : "";
          }
        }
      ]
    };
  },
  computed: {
    ...mapState("orders", {
      orders: state => state.orders,
      loadingData: state => state.loadingData,
      searchFields: s => s.searchFields,
      userHelper: s => s.userHelper
    }),
    ...mapGetters("orders", ["orderList", "searchOrderTypeOptions"])
  },
  methods: {    
    formattedDate(dateString) {
      var finalDateString;
      // var d = new Date(dateString);
      // var mm = d.getMonth() + 1;
      // var dd = d.getDate();
      // var yy = d.getFullYear();
      // var hh = d.getHours();
      // var hours = d.getHours();
      // var minutes = d.getMinutes();
      // var seconds = d.getSeconds();
      // hours = hours % 12;
      // hours = hours ? hours : 12; // the hour '0' should be '12'
      // minutes = minutes < 10 ? "0" + minutes : minutes;
      // seconds = seconds < 10 ? "0" + seconds : seconds;

      // if (mm < 10) {
      //   mm = "0" + mm;
      // }
      // if (dd < 10) {
      //   dd = "0" + dd;
      // }
      // if (dd < 10) {
      //   dd = "0" + dd;
      // }
      
      // var strTime = hours + ":" + minutes + ":" + seconds;
      // finalDateString = mm + "/" + dd + "/" + yy+" "+strTime;
      finalDateString = date.formatDate(dateString, 'M/D/YY h:mm A')

      return finalDateString;
    },
    ...mapActions("orders", ["fetch", "one", "addNew", "exportExcel", 'fetchSearchOrderTypes']),
    ...mapMutations("orders", [
      "openOrderType",
      "openOrderManagementModal",
      "paymentModalOpenState",
      "detailsModalOpen",
      "setSearchUserHelper",
      "clearSearchFields",
      "setSelectedSearchUser"
    ]),
    formatUserInitials(user) {
      return user.USER_FIRST_NAME[0] + user.USER_LAST_NAME[0];
    },
    selectUser (val){
      let vm = this
      let text = val ? val.item.USER_FIRST_NAME + ' ' + val.item.USER_LAST_NAME : ''
      vm.setSearchUserHelper(text)
      vm.setSelectedSearchUser(val)
      vm.search()
    },
    fetchAndClear(){
      let vm = this
      vm.clearSearchFields()
      vm.selectUser(null)
    },
    search(){
      let vm = this
      vm.$root.$emit('refreshGrid:ordersGrid')
    }
  }
};
</script>

<template>
  <q-page id="order-page" class="stretch-grid has-search" color="white">
    <q-collapsible class="search-box" collapse-icon="fa fa-angle-down">
      <template slot="header" class="search-box">
        <h5 style="padding: 12px 0px 12px 13px;width: 100%;">
          <q-icon name="fa fa-search" color="primary" style="padding:0 5px 3px" />Orders Search
        </h5>
      </template>
      <form v-on:submit.prevent="">
        <div class="sl-row no-margin">
          <div class="sl-col-4"><q-input float-label="Order ID" v-model="searchFields.ORDER_ID" /></div>
          
          <div class="sl-col-4">
              <q-field>
                <q-select
                    float-label="Order Type"
                    v-model="searchFields.LK_ORDER_TYPE_ID"
                    :options="searchOrderTypeOptions"
                />
            </q-field>
          </div>
          <div class="sl-col-4"><q-input float-label="Class ID" v-model="searchFields.CLASS_ID" /></div>
        </div>
        <div class="sl-row no-margin">
          <div class="sl-col-4">
            <q-datetime
                clearable
                v-model="searchFields['ORDER_START_DATE']"
                :before="[{icon: 'calendar_today' }]"
                @clear="search()"
                type="date"
                format="MM/DD/YYYY"
                float-label="Order Start Date"
                popover
              /> 
          </div>
          <div class="sl-col-4">
            <q-datetime
                clearable
                v-model="searchFields['ORDER_END_DATE']"
                :before="[{icon: 'calendar_today' }]"
                @clear="search()"
                type="date"
                format="MM/DD/YYYY"
                float-label="Order End Date"
                popover
              />
          </div>
          <div class="sl-col-4">
            <div style="height:12px;">
            </div>
            <user-auto-complete 
                :onSelect="selectUser"
                :userId="searchFields.USER_ID"
                placeholder="Search Users by Name, Email"
                clearable
                :clear="search"
                v-bind:helper="userHelper"
                v-if="$p(['ADMIN','MANAGER'],'or')"
            />
          </div>
        </div>

        <q-toolbar color="white" style="padding-right:60px">
          <q-toolbar-title></q-toolbar-title>
          <q-btn color="secondary" label="Clear" outline size="sm" type="reset" style="margin-right:5px" @click="fetchAndClear"/> 
          <q-btn color="primary" label="Search" size="sm" type="submit" @click="search()" />
        </q-toolbar>
      </form>
    </q-collapsible>
    <!-- content -->
    <Grid
      id="ordersGrid"
      class="fit"
      :module="module"
      :data="orderList"
      :visibleColumns="visibleColumns"
      :columns="columnOptions"
      :pagination="pagination"
      :onLaunch="one"
      :onRequest="fetch"
      :onExport="fetch"
      :loading="loadingData"
      :filterable="filterable"
    >
      <template slot="col-item-notes" slot-scope="props">
        <div style="max-width: 250px;overflow:hidden;text-overflow:ellipsis;" :title="props.value">{{props.value}}</div>
      </template>
      <template slot="col-item-status" slot-scope="props">
        <div
          style="display:inline-block;margin-left: 10px;border-radius:30px"
          class="label"
          :class="{
                  'blue': props.value == 'Placed',
                  'green' : props.value =='Completed' || props.value =='Fulfilled',
                  'red' : props.value =='Cancelled' || props.value == 'Unpaid'
              }"
        >{{props.value || '?'}}</div>
      </template>
      <template slot="col-item-user" slot-scope="props">
        <div
          class="label green round small"
          style="font-size: 11px;padding: 6px 0px;margin-right: 5px"
        >{{formatUserInitials(props.value)}}</div>
        {{props.value.USER_FIRST_NAME}} {{props.value.USER_LAST_NAME}}
      </template>
    </Grid>
    <!-- <details-modal :module="module" /> -->
    <order-management-modal/>
    <!-- <order-type-modal /> -->
    <q-layout-footer>
      <q-toolbar>
        <q-toolbar-title></q-toolbar-title>
        <q-btn
          v-if="$p(['ADMIN'])"
          class="q-mx-md"
          label="Order Types"
          icon="fa fa-gear"
          color="blue"
          outline
          @click="openOrderManagementModal()"
        ></q-btn>
        <q-btn
          label="New Order"
          icon="fa fa-plus"
          color="primary"
          @click="paymentModalOpenState(true)"
        ></q-btn>
      </q-toolbar>
    </q-layout-footer>
  </q-page>
</template>


<style lang="stylus">

// #order-header {
// min-height: 120px
// }
// #order-body {

// }
#order-page {
  display: flex;
}
</style>
